import { gql } from "apollo-boost";
import { ContentLoader } from 'components/common/loader/ContentLoader';
import { addOrInviteUsers, changeUserRole, getEvent, getUsers, updateEvent } from 'components/graphql/queries';
import { getTicketBankItemsAsString } from 'components/graphql/queries/ticketBank';
import * as JSCookie from 'js-cookie';
import { stripUriParamsString } from 'lib/utils/helpers';
import { EditEventForm } from 'pages/manage/events/edit/modules/edit.form';
import * as React from 'react';
import { Subscription } from "react-apollo";
import { connect } from 'react-redux';

import { Redirect } from 'react-router'
import { withRouter } from 'react-router-dom';
import { fetchGraphQL } from 'services/graphql/GraphQL';
import EventDucks from 'stores/ducks/Event.duck';
import UIDucks from 'stores/ducks/UI.duck';
import UserDucks from 'stores/ducks/User.duck'
import UsersDucks from 'stores/ducks/Users.duck';

import { updateTime } from 'components/graphql/queries'
import EventToolbar from '../detail/EventToolbar';

import Roles from '@istkt/lib/enums/Roles.enum';

interface IDashboardOverviewProps {

  user: any;
  token?: string;
  dispatch?: any;
  match?: any;
  location?: any;
  history?: any;
  users?: any;
  event?: object;
  isOpened?: any;
}



class EditEventsPage extends React.Component<IDashboardOverviewProps> {
  public state = {
    isLoading: true,
    event: { id: null, name: '' },
    eventTicketInventory: [],
    successDetail: false,
    successConfig: false,
    updateString: 0,
    updateString1: 0,
    updateString2: 0,
    updateString3: 0,
    updateString4: 0,
    updateString5: 0,
    updateString6: 0,
    updateComplete: 0
  };

  constructor(props) {
    super(props);
    this.handleDetailsSave = this.handleDetailsSave.bind(this);
    this.handleAddUsers = this.handleAddUsers.bind(this);
    this.handleUserChangeRole = this.handleUserChangeRole.bind(this);
    this.retrieveNeededData = this.retrieveNeededData.bind(this);
    this.reloadData = this.reloadData.bind(this);
    this.handleRoleChange = this.handleRoleChange.bind(this);
    this.handleAddCodes = this.handleAddCodes.bind(this);
  }

  public handleRoleChange(user: any) {
    this.props.dispatch(UserDucks.setUser(user));
    return undefined;
  }

  public componentDidMount() {
    this.retrieveNeededData();
    if (!this.props.isOpened) {
      return;
    }
    this.props.dispatch(UIDucks.setAppBar(!this.props.isOpened));
  }

  public retrieveNeededData() {
    const eventId = stripUriParamsString(this.props.match.params.eventId);
    fetchGraphQL(getEvent(eventId), JSCookie.get("token")).then(result => {
      this.setState({
        event: result.event.get
      });
      fetchGraphQL(getUsers(), JSCookie.get("token"), {
        ids: [
          ...result.event.get.promoters,
          ...result.event.get.checkers,
          ...result.event.get.hosts
        ].filter(item => {
          if (item !== null) {
            return item;
          }
        })
      }).then((resultUsers: any) => {
        if (resultUsers === undefined || resultUsers === null) {
          this.setState({
            isLoading: false
          });
        } else {
          if (resultUsers !== null) {
            this.setState({
              users: resultUsers.user.findByIds,
              isLoading: false
            });
            this.props.dispatch(UsersDucks.addUsers(resultUsers.user.findByIds));
          }
        }
      });
      fetchGraphQL(getTicketBankItemsAsString(), JSCookie.get("token"), {
        eventId
      }).then((resultInventory: any) => {
        this.setState({
          eventTicketInventory: JSON.parse(resultInventory.ticketBank.getAsString) || [],
          isLoading: false
        });
      });
    });
  }

  public handleDetailsSave(newData: any, logo?: boolean) {
    this.setState(
      (oldState: any) => {
        return {
          event: {
            ...oldState.event,
            ...newData
          },
          isLoading: true
        };
      },
      () => {
        const eventLocal: any = JSON.parse(JSON.stringify(this.state.event)); // eventLocal is a deep copy now

        const time = eventLocal.time;
        const type = eventLocal.type;

        // delete unneccassary information
        delete eventLocal.checkers;
        delete eventLocal.promoters;
        delete eventLocal.hosts;
        delete eventLocal.publicTickets;
        delete eventLocal.totalPublic;
        delete eventLocal.totalPrivate;
        delete eventLocal.revenueTotal;
        delete eventLocal.boughtTotal;
        delete eventLocal.averageDayRevenue;
        delete eventLocal.totalRevenue;
        delete eventLocal.ticketCounts;
        delete eventLocal.ticketBreakBought;
        delete eventLocal.ticketBreakCheckedIn;
        delete eventLocal.ticketBreakCancelled;
        delete eventLocal.ticketBreakActivated;
        delete eventLocal.isActive;
        delete eventLocal.payoutTime;
        delete eventLocal.stripeFeeTotal;
        delete eventLocal.platFormFeeTotal;
        delete eventLocal.taxTotal;
        delete eventLocal.time;
        delete eventLocal.type;
        delete eventLocal.currency;
        delete eventLocal.capacityRemaining;

        eventLocal.configuration.maxTicketsPerType = Number(
          eventLocal.configuration.maxTicketsPerType
        );
        eventLocal.configuration.maxTicketsPerOrder = Number(
          eventLocal.configuration.maxTicketsPerOrder
        );
        eventLocal.configuration.quota = Number(eventLocal.configuration.quota);
        eventLocal.timezoneOffset = eventLocal.timezoneOffset.toString();
        eventLocal.creationTimeZone = eventLocal.timezoneOffset.toString();
        eventLocal.fees.perTicketFee = Number(eventLocal.fees.perTicketFee);
        eventLocal.fees.perOrderFee = Number(eventLocal.fees.perOrderFee);
        eventLocal.fees.taxPercentage = Number(eventLocal.fees.taxPercentage);

        fetchGraphQL(updateEvent(), JSCookie.get("token"), {
          event: eventLocal, eventId: stripUriParamsString(this.props.match.params.eventId)
        }).then(result => {
          time.eventId = this.state.event.id;
          fetchGraphQL(
            updateTime(), undefined, {
            time
          }
          )
          if (logo) {
            window.location.reload()
          }
          this.retrieveNeededData();
          if (type) {
            this.setState({
              isLoading: false,
              successDetail: true,
              successConfig: false
            });
          } else {
            this.setState({
              isLoading: false,
              successConfig: true,
              successDetail: false
            });
          }
        });
      }
    );
  }
  public handleAddUsers(newData: any) {
    this.setState(
      (oldState: any) => {
        return {
          isLoading: true
        };
      },
      () => {
        const trimmedEmails = newData.emails.toLowerCase().split("\n").map(item => {
          return item.trim()
        });
        fetchGraphQL(addOrInviteUsers(), JSCookie.get("token"), {
          emails: trimmedEmails,
          roleId: newData.role,
          eventId: this.state.event.id
        }).then(result => {
          this.retrieveNeededData();
        });
      }
    );
  }

  public handleAddCodes(newData: any) {
    this.setState(
      (oldState: any) => {
        return {
          isLoading: true
        };
      },
      () => {
        const trimmedEmails = newData.emails.toLowerCase().split("\n").map(item => {
          return item.trim() + '@isotope-referral-code.com'
        });
        console.log(trimmedEmails)
        fetchGraphQL(addOrInviteUsers(), JSCookie.get("token"), {
          emails: trimmedEmails,
          roleId: Roles.PROMOTER,
          eventId: this.state.event.id
        }).then(result => {
          this.retrieveNeededData();
        });
      }
    );
  }

  public handleUserChangeRole(userId: string, roleId: string) {
    this.setState(
      (oldState: any) => {
        return {
          isLoading: true
        };
      },
      () => {
        fetchGraphQL(changeUserRole(), JSCookie.get("token"), {
          userId,
          newRoleId: roleId,
          eventId: this.state.event.id
        }).then(result => {
          if (roleId === 'NOT_LOGGEDIN' && userId.trim() === this.props.user.id.trim()) {
            window.location.pathname = '/manage/events'
          } else {
            this.retrieveNeededData();
          }
        });
      }
    );
  }

  public reloadData(e: any, num) {
    switch (num) {
      case 0:
        this.setState({
          updateString: e
        })
        break;
      case 1:
        this.setState({
          updateString1: e
        })
        break;
      case 2:
        this.setState({
          updateString2: e
        })
        break;
      case 3:
        this.setState({
          updateString3: e
        })
        break;
      case 4:
        this.setState({
          updateString4: e
        })
        break;
      case 5:
        this.setState({
          updateString5: e
        })
        break;
      case 6:
        this.setState({
          updateString6: e
        })
        break;
      default:
        console.log('')
        break;
    }
    const eventId = stripUriParamsString(this.props.match.params.eventId);
    fetchGraphQL(getEvent(eventId), JSCookie.get("token")).then(result => {
      this.setState({
        event: result.event.get
      });
      fetchGraphQL(getUsers(), JSCookie.get("token"), {
        ids: [
          ...result.event.get.promoters,
          ...result.event.get.checkers,
          ...result.event.get.hosts
        ].filter(item => {
          if (item !== null) {
            return item;
          }
        })
      }).then((resultUsers: any) => {
        if (resultUsers === undefined || resultUsers === null) {
          this.setState({
            isLoading: false
          });
        } else {
          if (resultUsers !== null) {
            this.setState({
              users: resultUsers.user.findByIds,
              isLoading: false
            });
            this.props.dispatch(UsersDucks.addUsers(resultUsers.user.findByIds));
          }
        }
        fetchGraphQL(getTicketBankItemsAsString(), JSCookie.get("token"), {
          eventId
        }).then((resultInventory: any) => {
          this.setState({
            eventTicketInventory: JSON.parse(resultInventory.ticketBank.getAsString) || [],
            isLoading: false,
            updateComplete: Math.random().toString()
          });
        });
      });
    })

    return undefined;
  }

  public render() {

    const roleChange = gql`
      subscription {
        roleChange
      }
			`;
    const eventUpdated = gql`
      subscription {
        updatedEvent(eventId:"${this.props.match.params.eventId}")
      }
      `;

    const eventDeleted = gql`
      subscription {
        eventDeletedNowWhat(eventId:"${this.props.match.params.eventId}")
      }
      `;

    const ticketPurchase = gql`
      subscription {
        ticketPurchase(eventIds:"${stripUriParamsString(this.props.match.params.eventId)}")
      }
      `;

    const eventInformationUpdate = gql`
		subscription {
			eventDetailsUpdated(eventId:"${stripUriParamsString(this.props.match.params.eventId)}")
		}
		`;

    const ticketCheckin = gql`
      subscription {
        ticketCheckin(eventIds:"${stripUriParamsString(this.props.match.params.eventId)}")
      }
      `;

    const ticketActivation = gql`
      subscription {
        ticketActivated(eventIds:"${stripUriParamsString(this.props.match.params.eventId)}")
      }
      `;

    const ticketDecayed = gql`
      subscription {
        ticketDecayed(eventIds:"${stripUriParamsString(this.props.match.params.eventId)}")
      }
      `;

    const tab = new URLSearchParams(this.props.location.search).get("tab");
    const updateKey = String(this.state.updateString) +
      String(this.state.updateString1) +
      String(this.state.updateString2) +
      String(this.state.updateString3) +
      String(this.state.updateString4) +
      String(this.state.updateString5) +
      String(this.state.updateString6) + String(this.state.updateComplete);

    return (
      <div className="div_holder_2">
        <ContentLoader isLoading={this.state.isLoading}>
          <Subscription subscription={eventDeleted}>
            {({ data }) => {
              if (data !== undefined && data !== null && data.eventDeletedNowWhat === true) {
                return <Redirect to="/manage/events" />;
              }
              return null;
            }}
          </Subscription>
          <Subscription subscription={roleChange}>
            {({ data }) => {
              if (data !== undefined && data !== null && data.roleChange !== null && data.roleChange.length !== 0) {
                window.location.pathname = '/manage/events'
              }
              return null;
            }}
          </Subscription>
          {
            window.location.search !== "?tab=publicTickets"
              && window.location.search !== "?tab=privateTickets"
              && window.location.search !== "?tab=referrals" ?
              <div>
                <Subscription subscription={eventInformationUpdate}>
                  {({ data }) => {
                    if (data !== undefined && data !== null && data.eventDetailsUpdated !== null) {
                      if (data.eventDetailsUpdated !== this.state.updateString1) {
                        return <img height="0" width="0" style={{ display: 'none' }} onLoad={this.reloadData(data.eventDetailsUpdated, 1)} />
                      }
                    }
                    return null;
                  }}
                </Subscription>
                <Subscription subscription={ticketCheckin}>
                  {({ data }) => {
                    if (data !== undefined && data !== null && data.ticketCheckin !== null) {
                      if (data.ticketCheckin !== this.state.updateString3) {
                        return <img height="0" width="0" style={{ display: 'none' }} onLoad={this.reloadData(data.ticketCheckin, 3)} />
                      }
                      return null;
                    }
                    return null;
                  }}
                </Subscription>

                <Subscription subscription={ticketActivation}>
                  {({ data }) => {
                    if (data !== undefined && data !== null && data.ticketActivated !== null) {
                      if (data.ticketActivated !== this.state.updateString4) {
                        return <img height="0" width="0" style={{ display: 'none' }} onLoad={this.reloadData(data.ticketActivated, 4)} />
                      }
                      return null;
                    }
                    return null;
                  }}
                </Subscription>

                <Subscription subscription={ticketPurchase}>
                  {({ data }) => {
                    if (data !== undefined && data !== null && data.ticketPurchase !== null) {
                      if (data.ticketPurchase !== this.state.updateString2) {
                        return <img height="0" width="0" style={{ display: 'none' }} onLoad={this.reloadData(data.ticketPurchase, 2)} />
                      }
                      return null;
                    }
                    return null;
                  }}
                </Subscription>
                <Subscription subscription={ticketDecayed}>
                  {({ data }) => {
                    if (data !== undefined && data !== null && data.ticketDecayed !== null) {
                      if (data.ticketDecayed !== this.state.updateString5) {
                        return <img height="0" width="0" style={{ display: 'none' }} onLoad={this.reloadData(data.ticketDecayed, 5)} />
                      }
                      return null;
                    }
                    return null;
                  }}
                </Subscription>
              </div>
              : null
          }
          <Subscription subscription={eventUpdated}>
            {({ data }) => {
              if (data !== undefined && data !== null && data.updatedEvent !== null
                && window.location.search !== "?tab=publicTickets"
                && window.location.search !== "?tab=privateTickets"
                && window.location.search !== "?tab=referrals"
              ) {
                if (data.updateEvent !== this.state.updateString) {
                  return <img height="0" width="0" style={{ display: 'none' }} onLoad={this.reloadData(data.updateEvent, 0)} />
                }
                return null;
              }
              return null;
            }}
          </Subscription>
          <div>
            <p />
            <EventToolbar eventId={this.state.event.id} key={this.props.user.id + tab} settings={true} eventName={this.state.event.name} userId={this.props.user.id} />
            <p><br /></p>
          </div>
          <EditEventForm
            event={this.state.event}
            ticketInventory={this.state.eventTicketInventory}
            users={this.props.users}
            onSave={this.handleDetailsSave}
            onAddUsers={this.handleAddUsers}
            handleAddCodes={this.handleAddCodes}
            onChangeUserRole={this.handleUserChangeRole}
            tabName={tab || "details"}
            saveSuccessConfig={this.state.successConfig}
            saveSuccessDetail={this.state.successDetail}
            key={updateKey}
            user={this.props.user}
          />
        </ContentLoader>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    events: EventDucks.getEvents(state),
    users: UsersDucks.getUsers(state),
    user: UserDucks.getUser(state),
    isOpened: UIDucks.getIsAppBarOpen(state)
  };
};
export default withRouter(connect(mapStateToProps)(EditEventsPage));


// WEBPACK FOOTER //
// ./src/pages/manage/events/edit/EditEvent.page.tsx